import { inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';
import { TooltipUnsavedChangesService } from '../shared/services/tooltip-unsaved-changes.service';

// The tooltip admin toolbar is not a routed component, so a canDeactivate guard
// never sees it. canActivateChild on the shell route runs on every page change
// instead.
export const tooltipUnsavedChangesGuard: CanActivateChildFn = () =>
  inject(TooltipUnsavedChangesService).confirmLeave();
